import mortgagesApi from '@/api/MortgagesApi';

const state = {
  mortgageSimulations: undefined,
  mortgageFromCashflow: undefined,
};

const getters = {
  monthlyDiscountTotals: state => state.mortgageSimulations?.lowerMonthlyLowerTotal || state.mortgageSimulations?.lowerMonthlySameTotal,
  totalDiscountTotals: state => state.mortgageSimulations?.sameMonthlyLowerTotal,
  currentMortgageTotals: state => state.mortgageSimulations?.currentSimulation,
  mortgageFromCashflow: state => state.mortgageSimulations?.mortgageFromCashflow,
  hasMortgageAlternatives: state => {
    if (!state.mortgageSimulations) { return false; }
    return !!(state.mortgageSimulations.lowerMonthlyLowerTotal
      || state.mortgageSimulations.lowerMonthlySameTotal
      || state.mortgageSimulations.sameMonthlyLowerTotal);
  },
};

const actions = {
  async fetchMortgageSimulations({ commit }) {
    const { simulations, mortgageFromCashflow } = await mortgagesApi.getMortgagesSimulations();
    commit('setMortgageSimulations', simulations);
    commit('setMortgageFromCashflow', mortgageFromCashflow);
  },
};

const mutations = {
  setMortgageSimulations(state, simulations) {
    state.mortgageSimulations = simulations;
  },
  setMortgageFromCashflow(state, mortgageFromCashflow) {
    state.mortgageFromCashflow = mortgageFromCashflow;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
